import { Card, Col, Row } from "antd";
import '../dashboard.css'
import React, { } from "react";
import { CardBodyDetails, CardDetail, CardHeaderBody } from "@gtpl/shared-models/common-models";


export interface cardProps {
    cardData: CardDetail
}

export const CardComponet = (props: cardProps) => {
    const { cardData } = props;

    const constructLocationDetail = (bodyDetail: CardBodyDetails[]) => {
        console.log(bodyDetail);
        return bodyDetail.map(bodyProps =>
            <tr style={{ borderBottom: '1px solid #ccc', lineHeight: ' 1.8em' }}>
                <td style={{ width: '40%' }}>{bodyProps.cardBodyTitle}</td>
                <td style={{ width: '30%' }}>{bodyProps.cardBodyParam1}</td>
                <td style={{ width: '30%' }}>{bodyProps.cardBodyParam2}</td>
            </tr>
        )
    }

    const constructTableHeader = (headers: string[]) => {
        return headers.map(head => <th style={{ borderBottom: '1px solid #ccc', lineHeight: ' 1.8em', marginBottom: '10px' }}>{head}</th>)
    }
    return (
        <>
            <Card className="totalsocard" title={<span style={{marginBottom: '10px'}}className="title">{cardData.carHeader.cardHeaderTitle}</span>} bordered={false} style={{ color: 'white', height:'100%' }}>
                <Row style={{ width: '100%', height: '20px' }}>
                    <Col span={10}>
                        {cardData.carHeader.cardHederData[0].title}
                    </Col>
                    <Col span={10} offset={2}>
                        {cardData.carHeader.cardHederData[1].title}
                    </Col>
                </Row>
                <Row>
                    <Col span={10} style={{fontSize:'30px'}}>
                        {cardData.carHeader.cardHederData[0].value}
                    </Col>
                    <Col span={10} offset={2} style={{fontSize:'30px'}}>
                        {cardData.carHeader.cardHederData[1].value}
                    </Col>
                </Row>
                <table cellPadding="0" style={{ borderCollapse: 'collapse', width: '100%', margin: '1.5em', fontSize: '0.85em', border: '0' }}>
                        {constructTableHeader(cardData.tableHeaders)}
                    <tbody>
                        {constructLocationDetail(cardData.cardBody)}
                    </tbody>
                </table>
            </Card>
        </>
    );
}
export default CardComponet;